import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BACKGROUND_REQUEST, PageProgressService } from '../services/page-progress.service';

/** The page progress bar waits for the GETs the opened page starts; background ones opt out. */
export const pageProgressInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET' || req.context.get(BACKGROUND_REQUEST)) return next(req);
  return inject(PageProgressService).track(next(req));
};
